import { defineComponent, onMounted, ref } from '@nuxtjs/composition-api';
export default defineComponent({
    name: 'EditLink',
    props: {
        path: {
            default: '',
            type: String,
        },
    },
    setup(props) {
        const shouldRender = ref(false);
        const link = ref('');
        onMounted(async () => {
            if (!props.path) {
                return;
            }
            const { default: Cookies } = await import(
            /* webpackChunkName: "js-cookie" */
            'js-cookie');
            try {
                const jwtValue = Cookies.get('forbes_jwt');
                if (jwtValue) {
                    shouldRender.value = !!JSON.parse(jwtValue);
                }
                let baseUrl = 'https://iris.forbes.ru';
                if (/-canary(\.branch)*.forbes|localhost/gi.test(location.href)) {
                    baseUrl = 'https://dev-iris.forbes.ru';
                }
                link.value = `${baseUrl}${props.path}`;
            }
            catch { }
        });
        return {
            link,
            shouldRender,
        };
    },
});
